import React from 'react';
import { useTranslation } from 'react-i18next';
import { DollarCircleOutlined } from '@ant-design/icons';

export const PriceCard = ({ price }) => {
    const { t } = useTranslation('reportPage');

    return (
        <section id="price" className="card side-card price" aria-labelledby="price-title">
            <div className="price-head">
                <span id="price-title" className="eyebrow price-eyebrow">
                    <DollarCircleOutlined aria-hidden="true" />
                    {t('layout.auctionVehicle')}
                </span>
                {price.city && (
                    <span className="price-place">
                        {price.flag && (
                            <img src={`https://flagcdn.com/w40/${price.flag}.png`} alt="" className="price-flag" />
                        )}
                        {price.city}
                    </span>
                )}
            </div>
            <div className="price-value">{price.amount}</div>
            <span className="price-label">{t('layout.finalSellingPrice')}</span>
        </section>
    );
};
